
export const ROLE_CONFIG = {
    Manager: {
        name: 'Manager',
        pages: ['/settings', '/facilities', '/users', '/calendar', '/profile', '/agent-files', '/workflows'],
        defaultPage: '/calendar',
        canAccessSchedule: false,
    },
    Provider: {
        name: 'Provider',
        pages: ['/settings', '/schedule', '/profile', '/calendar'],
        defaultPage: '/schedule',
        canAccessSchedule: true,
    },
    Observer: {
        name: 'Observer',
        pages: ['/settings', '/calendar', '/facilities', '/profile', '/agent-files', '/workflows'],
        defaultPage: '/calendar',
        canAccessSchedule: false,
    },
};

export const canAccessPage = (userRole, pagePath) => {
    const roleConfig = ROLE_CONFIG[userRole];
    if (!roleConfig) return false;
    // Match exact page or any nested route (e.g. /workflows/:id → allowed by /workflows)
    return roleConfig.pages.some(
        (p) => pagePath === p || pagePath.startsWith(p + "/"),
    );
};

export const getDefaultPage = (userRole) => {
    return ROLE_CONFIG[userRole]?.defaultPage || '/schedule';
};

export const canAccessSchedule = (userRole) => {
    return ROLE_CONFIG[userRole]?.canAccessSchedule || false;
}; 